import React from 'react';
import CommonModal from '../../../../components/common/CommonModal';
import './HRPTracking.css'
import RedInfoIcon from '../../../../assets/svg/exclamation.svg'
import ButtonModal from '@components/common/Button';

interface WarningModalProps {
  handleCloseModal: () => void;
  hrpType: string;
  showWarningModal: any;
  handleWarningModalBackButton: () => void;
  handleFinalProceed: () => void;
}

const HRPWarningModal: React.FC<WarningModalProps> = ({ handleCloseModal, hrpType, showWarningModal, handleWarningModalBackButton, handleFinalProceed }) => {

  return (
    <CommonModal
      show={showWarningModal}
      handleClose={handleCloseModal}
      handleCustomBackButton={handleWarningModalBackButton}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleFinalProceed}
            id="cancel"
            buttonName={'Yes, Proceed'}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <h4 className='header-text'>Add HRP Condition</h4>
        <div className='warning-text'>Do you surely want to add <span className='text-bold'>{hrpType}</span> to Beneficiary`s Profile?</div>
      </div>
    </CommonModal>
  );
};

export default HRPWarningModal;
